import { useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import AddressesIcon from 'assets/settings/AddressesIcon';
import CompetitorIcon from 'assets/settings/CompetitorIcon';
import ImportLeadIcon from 'assets/settings/ImportLeadIcon';
import LeadSourcesIcon from 'assets/settings/LeadSourcesIcon';
import NotificationsIcon from 'assets/settings/NotificationsIcon';
import OffersIcon from 'assets/settings/OffersIcon';
import PrivilegesIcon from 'assets/settings/PrivilegesIcon';
import ProductsIcon from 'assets/settings/ProductsIcon';
import WorkflowStatusesIcon from 'assets/settings/WorkflowStatusesIcon';

import {
  MainWrapper,
  SalesNewSettingsContainer,
  SalesNewSettingsTabs,
  TabButton,
  TabContent,
} from './SalesNewSettings.styles';
import Addresses from './addresses';
import Competitor from './competitor';
import ImportLead from './importLead';
import LeadSources from './leadSources';
import Notifications from './notifications';
import Offers from './offers';
import Privileges from './privileges';
import Products from './products';
import WorkflowStatuses from './workflowStatuses';

const tabs = [
  { id: 'lead-sources', name: 'Sources', component: LeadSources, icon: LeadSourcesIcon },
  { id: 'import-lead', name: 'Import Lead', component: ImportLead, icon: ImportLeadIcon },
  { id: 'products', name: 'Products', component: Products, icon: ProductsIcon },
  { id: 'offers', name: 'Offers', component: Offers, icon: OffersIcon },
  {
    id: 'workflow-statuses',
    name: 'Statuses',
    component: WorkflowStatuses,
    icon: WorkflowStatusesIcon,
  },
  { id: 'competitor', name: 'Competitor', component: Competitor, icon: CompetitorIcon },
  { id: 'privileges', name: 'Privileges', component: Privileges, icon: PrivilegesIcon },
  {
    id: 'notifications',
    name: 'Notifications',
    component: Notifications,
    icon: NotificationsIcon,
  },
  { id: 'addresses', name: 'Addresses', component: Addresses, icon: AddressesIcon },
];

const SalesNewSettings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');

  const initialTab = tabs.find((tab) => tab.id === tabFromUrl) ? tabFromUrl : 'lead-sources';
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    if (activeTab !== tabFromUrl) {
      setSearchParams({ tab: activeTab }, { replace: true });
    }
  }, [activeTab, tabFromUrl, setSearchParams]);

  useEffect(() => {
    if (tabFromUrl && tabs.find((tab) => tab.id === tabFromUrl)) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

  return (
    <SalesNewSettingsContainer>
      <MainWrapper>
        <SalesNewSettingsTabs>
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <TabButton
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                $active={activeTab === tab.id}
              >
                {Icon && <Icon />}
                {tab.name}
              </TabButton>
            );
          })}
        </SalesNewSettingsTabs>
        <TabContent>{ActiveComponent && <ActiveComponent />}</TabContent>
      </MainWrapper>
    </SalesNewSettingsContainer>
  );
};

export default SalesNewSettings;
